import { UntypedFormGroup } from '@angular/forms'
import moment from 'moment-timezone'

import { Clinician } from '../../model/clinician'
import { CustomQuestionSchema } from '../../schema'
import { maxDateValidator, minDateValidator } from '../../validators'
import { PatientIntakeFormData } from '../intake-form-data.class'
import { QuestionBase, QuestionOptions } from './base.question.class'

interface DateQuestionOptions extends QuestionOptions<Date> {}

export class DateQuestion extends QuestionBase<Date> {
  controlType = 'date'
  type = 'date'
  hint = ''

  constructor(options: DateQuestionOptions = {}) {
    super(options)

    this.mask = {
      mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    }
  }

  set value(value: Date) {
    if (this.control) {
      this.control.controls['value'].setValue(value)
    }
    this._value = value
  }

  get value(): Date {
    if (this._value) {
      return moment(this._value, 'YYYY-MM-DD').toDate()
    }
  }

  saveValueToData(
    data: PatientIntakeFormData,
    form: UntypedFormGroup,
    clinician: Clinician,
  ) {
    if (this.isCustom) {
      const customData: CustomQuestionSchema = {
        id: this.id,
        value: form.value[this.id].value,
        note: form.value[this.id].note,
      }

      data.saveCustomQuestion(customData, clinician.id)
    } else {
      data[this.key] = form.value[this.key].value || ''
    }
  }

  getValidators() {
    const validators = super.getValidators()

    if (this.min) {
      validators.push(minDateValidator(this.min))
    }

    if (this.max) {
      validators.push(maxDateValidator(this.max))
    }

    return validators
  }
}
